export const sendInput = (email) => {
    //let api = process.env.REACT_APP_EMAIL_API;
    let api = process.env.reactappemailapi;
    let url = api + '=' + email;
    console.log(url)
    return fetch(url)
        .then(response => console.log(response))
        .catch(error => console.error(error))
}